import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { BtnSuccess } from '../../../styles/Buttons';
import { Label, BlockForgot } from '../styles';
import { PoliticasDeSenha } from '../../../components/PoliticasDeSenha';

function CorpoPassword({ user }) {
  const [senha, setSenha] = useState('');

  return (
    <>
      <BlockForgot>
        <Typography.Title level={5}>
          <LockOutlined />
          Atualização de senha
        </Typography.Title>
        <Typography.Text>
          <b>{user.nome}</b>
          {`, Preencha todos os campos para realizar a
          atualização de senha.`}
        </Typography.Text>
      </BlockForgot>
      <Form.Item
        name="senha"
        label={<Label>Nova senha</Label>}
        rules={[
          { required: true, message: 'Por favor, entre com sua nova senha!' },
        ]}
      >
        <Input.Password
          size="large"
          type="password"
          placeholder="*****"
          autoComplete="current-password"
          onChange={e => setSenha(e.currentTarget.value)}
        />
      </Form.Item>
      <Form.Item
        name="confirmaSenha"
        label={<Label>Confirme a nova senha</Label>}
        rules={[
          { required: true, message: 'Por favor, confirme sua nova senha!' },
        ]}
      >
        <Input.Password
          size="large"
          type="password"
          placeholder="*****"
          autoComplete="current-password"
        />
      </Form.Item>
      <Form.Item>
        <BtnSuccess size="large" block htmlType="submit" id="entrar">
          Atualizar senha
        </BtnSuccess>
      </Form.Item>
      <PoliticasDeSenha senha={senha} />
    </>
  );
}

CorpoPassword.propTypes = {
  user: PropTypes.shape({
    nome: PropTypes.string,
  }).isRequired,
};
export default CorpoPassword;
